import type { StartableWorkflow } from '../models/company-workflow.js';

export function matchesStartable(startable: StartableWorkflow, query: string): boolean {
  return [startable.title, startable.ownerCompanyName].some((text) => text.toLowerCase().includes(query));
}

// A relationship's own description, or its place in the list when it has none
export function relationshipLabel(relationship: { description: string }, index: number): string {
  return relationship.description.trim() || `Relationship ${index + 1}`;
}
